import React from "react";
import UserContext from 'context/UserContext';
import Icon from "storybookComponents/Icon.js";
import Popover from '@material-ui/core/Popover';
import { withStyles } from "@material-ui/core";
import Item from "./item";
import { APPROVAL_REQUEST } from "constants/fixed-labels";
import { Card, CardContent, CardHeader } from "@material-ui/core";
import { Link } from "react-router-dom";
import styles from "./style";
import TimeAgo from 'javascript-time-ago'
import en from 'javascript-time-ago/locale/en'
import taskLoader from './Load';
import IconButton from '@material-ui/core/IconButton';

try {
  TimeAgo.addDefaultLocale(en)
}
catch (err) { }

const btn = (propertyid, classes) => (
  <Link to={`/${propertyid}/approvals`} style={{ color: "#000" }}>
    <p className={classes.btnlink}>See All</p>
  </Link>
);

const Tasks = ({ classes, orgLevel, pool }) => {
  const { subOrgDetails } = React.useContext(UserContext);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [tasks, setTasks] = React.useState([])

  React.useEffect(() => {
    init();
    let interval = pool ? setInterval(init, 5000) : null
    return () => {
      if (pool)
        clearInterval(interval)
    }
  }, [1])

  const init = async () => {
    try {
      let resp = await taskLoader(subOrgDetails.org.id);
      let t = resp.approvalRequests ? resp.approvalRequests.edges || [] : [];
      setTasks(t)
    }
    catch (err) {
      console.log("task err : ", err)
    }

  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const counts = tasks.length;
  if (typeof window.parent.approvalNotif === "function" && tasks.length) window.parent.approvalNotif(tasks, tasks.length);
  let new_request = tasks.map(e => e.node.hyevent.id).toString();

  if (localStorage.getItem("my_approver_requests") !== new_request)
    localStorage.setItem("my_approver_requests", new_request);



  return (
    <>
      <IconButton className={classes.container} onClick={handleClick}>
        <Icon onClick={handleClick} type="icon-c-check" className={classes.colorIcon} size="sm" />
        {
          counts ? <p className={classes.badge} onClick={handleClick}>{counts}</p> : null
        }
      </IconButton>


      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        classes={{
          paper: classes.paperClass,
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div className={orgLevel ? classes.bodyContainerorg : classes.bodyContainer}>
          <div className={classes.arrow} />
          <Card className={classes.root}>
            <CardHeader
              subheader={`Approval Queue (${tasks.length})`}
              classes={{
                root: classes.cardHeader,
                subheader: classes.subheader,
                action: classes.action_volume,
              }}
              action={btn(subOrgDetails.id, classes)}
            />
            <CardContent className={classes.card_content + " " + classes.withoutPadding}>
              <div className={classes.popoverBody}>
                {tasks.map(({ node: { hyevent, createdAt, propertyId } }) => <Item key={hyevent.id} {...hyevent} subtitle={APPROVAL_REQUEST(hyevent, subOrgDetails.timezoneString)} timecreated={createdAt} to={`/${propertyId}/event/${hyevent.id}`} />)}
              </div>
            </CardContent>
          </Card>
        </div>
      </Popover>

    </>
  )
}



export default withStyles(styles)(Tasks);































